import React from 'react'
import Modal from './Modal'

export default ({}) => (
    <Modal>
        <div>
            <header>
                <h2 className="title">Other Resources</h2>
            </header>
            <div>For practitioner’s tips from Ascent Environmental:</div>

            <ul
                className="bullets"
                style={{
                    marginTop: '0',
                    marginBottom: '15px'
                }}
            >
                <li>
                    <a
                        href="http://ascentenvironmental.com/files/2615/9423/5146/Practioners_Tools_Statutory_Exemptions.pdf"
                        target="_blank"
                    >
                        Statutory Exemptions for Housing Projects
                    </a>
                </li>
                <li>
                    <a
                        href="http://ascentenvironmental.com/files/3915/9423/5107/Practioners_Tools_Categorical_Exemptions.pdf"
                        target="_blank"
                    >
                        Categorical Exemptions for Housing Projects
                    </a>
                </li>
            </ul>
        </div>

        <p className="has-text-weight-bold">
            For more information on how to use a CEQA exemption or streamlining provision, please see AEP’s{' '}
            <a href="https://ceqaportal.org/tp/CEQA%20Exemptions%20Paper%202020%20Update.pdf" target="_blank">
                CEQA Portal Topic Paper.
            </a>
        </p>
        <p>
            Not all CEQA provisions that may apply to a housing project have been included in this tool. Site Check is
            focused on the CEQA provisions that cover a variety of housing types. Based on the specifics of the project,
            users should also consider the following provisions:
        </p>
        <ul className="bullets">
            <li>
                <strong>Affordable Housing</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=21159.23.&lawCode=PRC"
                    target="_blank"
                >
                    PRC § 21159.23
                </a>{' '}
                - CEQA statutory exemption for construction, conversion, or use of residential housing consisting of 100
                or fewer units that is affordable to low-income households.
            </li>
            <li>
                <strong>Agricultural Employee Housing</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=21159.22.&lawCode=PRC"
                    target="_blank"
                >
                    PRC § 21159.22
                </a>{' '}
                - CEQA statutory exemption for the construction, conversion, or use of residential housing for
                agricultural employees.{' '}
            </li>
            <li>
                <strong>Motel to Supportive Housing Conversions</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=21080.50.&lawCode=PRC"
                    target="_blank"
                >
                    PRC § 21080.50
                </a>{' '}
                - CEQA statutory exemption for the conversion of a hotel, motel, apartment hotel, transient occupancy
                residential structure, or hostel for transitional and supportive housing. This exemption expires on
                January 1, 2025.
            </li>
            <li>
                <strong>Existing Facility Reuse - Class 1</strong>,{' '}
                <a
                    href="https://govt.westlaw.com/calregs/Document/I089D09DBD6F34EDABE82C98F345D938A?viewType=FullText&originationContext=documenttoc&transitionType=CategoryPageItem&contextData=(sc.Default)"
                    target="_blank"
                >
                    CEQA Guidelines § 15301
                </a>{' '}
                - CEQA categorical exemption for the operation, repair, maintenance, permitting, leasing, licensing, or
                minor alteration of existing public or private structures, facilities, mechanical equipment, or
                topographical features, involving negligible or no expansion of existing or former use. As a categorical
                exemption, this provision is subject to the limitations contained in CEQA Guidelines § 15300.2.
            </li>
        </ul>

        <h6 className="title is-6">Ministerial/By Right Considerations</h6>
        <p>
            CEQA applies when a governmental agency can exercise judgment in deciding whether and how to carry out or
            approve a project. This makes the project “discretionary.” (CEQA Guidelines, § 15357.) Where the law
            requires a governmental agency to act on a project using fixed standards and the agency does not have
            authority to use its own judgment, the project is called “ministerial,” and CEQA does not apply. (CEQA
            Guidelines, §§ 15268(a), 15369.)
        </p>
        <p>
            State and local laws and guidelines should be consulted when determining whether a project may be
            ministerial or "by right."
        </p>
        <p>
            <u>State Legislation:</u>
        </p>
        <ul className="bullets">
            <li>
                <strong>SB 35</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65913.4.&lawCode=GOV"
                    target="_blank"
                >
                    GOV § 65913.4
                </a>{' '}
                - Creates a streamlined approval process for developments in localities that have not yet met their
                housing targets, provided that the development is on an infill site and complies with existing
                residential and mixed-use zoning. Participating developments must provide at least 10 percent of units
                for lower-income families. All projects over 10 units must be prevailing wage and larger projects must
                use skilled and trained labor. See the SB 35 section of{' '}
                <a href="https://www.hcd.ca.gov/policy-research/lhp.shtml" target="_blank">
                    https://www.hcd.ca.gov/policy-research/lhp.shtml
                </a>
                .
            </li>
            <li>
                <strong>AB 2162</strong> –{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?lawCode=GOV&division=1.&title=7.&part=&chapter=3.&article=11."
                    target="_blank"
                >
                    GOV § 65650-65656
                </a>{' '}
                - Allows for by-right development for supportive housing anywhere zoned for multifamily and mixed-use
                housing.
            </li>
            <li>
                <strong>AB 430</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65913.15.&lawCode=GOV"
                    target="_blank"
                >
                    GOV § 65913.15
                </a>{' '}
                - Establishes a ministerial approval process for housing development in the cities of Biggs, Corning,
                Gridley, Live Oak, Orland, Oroville, Willows and Yuba City. These provisions expire on January 1, 2026.
            </li>

            <li>
                <strong>AB 2011</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65912.100.&lawCode=GOV"
                    target="_blank"
                >
                    GOV §§ 65912.100
                </a>
                –
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65912.140.&lawCode=GOV"
                    target="_blank"
                >
                    65912.140
                </a>{' '}
                - Creates a ministerial, streamlined approval process for 100% affordable housing projects in commercial
                zones and for mixed-income housing projects along commercial corridors, and makes qualifying projects
                allowable uses in commercially zoned areas. Projects must meet specified objective development standards
                and labor standards. These provisions go into effect on July 1, 2023 and are set to be repealed on
                January 1, 2033.
            </li>

            <li>
                <strong>SB 6</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65852.24.&lawCode=GOV"
                    target="_blank"
                >
                    GOV § 65852.24
                </a>{' '}
                - Establishes housing as an allowable use on any parcel zoned for office or retail uses for projects
                that meet specified requirements. Allows these housing projects to utilize the existing ministerial, by
                right approval process outlined in SB 35 (
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65913.4.&lawCode=GOV"
                    target="_blank"
                >
                    GOV § 65913.4
                </a>
                ). Goes into effect on July 1, 2023 and is set to be repealed on January 1, 2033.
            </li>

            <li>
                <strong>SB 4</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65913.16.&lawCode=GOV"
                    target="_blank"
                >
                    GOV § 65913.16
                </a>{' '}
                - Allows for by-right development for housing development projects on land owned prior to January 1, 2024 by an independent institution of higher education or a religious institution. All of the units in the housing development must be for lower income households, except that 20% of the units may be for moderate-income households and 5% may be for staff of the institution of higher education or religious institution.
            </li>

            <li>
                <strong>SB 684</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65852.28.&lawCode=GOV"
                    target="_blank"
                >
                    GOV §§ 65852.28</a>, <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65913.4.5.&lawCode=GOV"
                    target="_blank"
                >65913.4.5</a>, <a
                href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=66499.41.&lawCode=GOV"
                target="_blank"
                >66499.41</a>{' '}
                - Requires local agencies to ministerially approve a parcel map or a tentative and final map for a housing development with 10 or fewer units on an urban lot of less than 5 acres that meets specified requirements. Allows housing development projects on a ministerially approved parcel map or tentative and final map to comply with objective standards and prohibits local agencies from imposing requirements on the project inconsistent with the bill’s requirements. Additionally, the bill requires local agencies to issue the building permits for housing projects where the applicant has received a tentative map approval or parcel map approval and meets other requirements.
            </li>

            <li>
                <strong>SB 9</strong> -{' '}
                <a
                    href="http://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=65852.21.&lawCode=GOV"
                    target="_blank"
                >
                    GOV § 65852.21
                </a>{' '}
                - Requires that housing developments containing no more than two residential units within a single-family residential zone be considered ministerially where certain requirements are met.
            </li>


        </ul>
        <p style={{ marginTop: '10px' }}>
            <u>Local Legislation:</u>
        </p>
        <p>
            Housing projects may also be by right under local the zoning code on certain parcels. Check with the
            appropriate local jurisdiction for more information. Note, where local discretion is limited to design
            review, the project may not be subject to CEQA. (See McCorkle Eastside Neighborhood Group v. City of St.
            Helena (2019) 31 Cal.App.5th 80.)
        </p>
    </Modal>
)
